export default __webpack_public_path__ + "static/media/ISMO CLASS-8 EXAM PATTERN 2025.0054560f.pdf";